import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZonarUIMaterialModule } from '@livemaps/material';
import { ZonarUiIconModule } from '@livemaps/icon';

@NgModule({
  imports: [ZonarUIMaterialModule, ZonarUiIconModule, CommonModule]
})
export class DriverModule {}
